import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { useSessionContext } from 'session'
import { type TableEntity, type UsFilters, UsTable, type Chamber, type State } from 'components'
import { type LegDistrict, type MemberFilterResults, memberListFilter } from 'services'
import { MemberFilters } from 'components'

export interface CommiteeFilters extends UsFilters {
  state: State | null
  chamber: Chamber | null
  district: LegDistrict | null
  firstName: string | null
  lastName: string | null
  email: string | null
}
export const MemberListePage: React.FC = () => {
  const { changeModuleName, changeUniqueId } = useSessionContext()
  const [committees, setMembers] = useState<TableEntity[]>([])
  const initialState: CommiteeFilters = {
    district: null,
    state: null,
    chamber: null,
    firstName: null,
    lastName: null,
    email: null,
    page: 1,
    order_field: 'last_name',
    order_direction: 'ASC'
  }

  const defaultAdditionalColumns = [
    { Header: 'First Name', accessor: 'person.firstName', order_field: 'first_name' },
    { Header: 'Last Name', accessor: 'person.lastName', order_field: 'last_name' },
    { Header: 'State', accessor: 'legseat.legdistrict.state.desc', order_field: 'state' },
    { Header: 'Chamber', accessor: 'legseat.legdistrict.legchamber.desc', order_field: 'chamber' },
    { Header: 'District', accessor: 'legseat.legdistrict.desc', order_field: 'district' },
    { Header: 'District Code', accessor: 'legseat.legdistrict.code', order_field: 'code' }

  ]

  const [filters, setFilters] = useState<CommiteeFilters>(initialState)
  const [lastQueriedFilters, setLastQueriedFilters] = useState<CommiteeFilters>(initialState)
  const [loadResultWithFilters, setLoadResultWithFilters] = useState(false)
  const [pageCount, setPageCount] = useState<number>(0)
  const [totalCount, setTotalCount] = useState<number | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { openNewTab } = useSessionContext()

  useEffect(() => {
    changeModuleName('Legislative Members')
    changeUniqueId('')
  }, [changeModuleName])

  const updateFilters = (filters: any): void => {
    setFilters(prevState => ({ ...prevState, ...filters }))
  }

  const cleanFilter = (): void => {
    const diff = JSON.stringify(initialState) === JSON.stringify(lastQueriedFilters)
    setFilters(initialState)
    if (!diff) { setLoadResultWithFilters(prevState => !prevState) }
  }

  const fetchMembers = async (): Promise<MemberFilterResults> => {
    setLoading(true)

    try {
      const params: any = {
        'chamber[]': filters.chamber != null ? [filters.chamber.id] : undefined,
        firstName: filters.firstName != null ? filters.firstName : undefined,
        lastName: filters.lastName != null ? filters.lastName : undefined,
        email: filters.email?.trim() !== '' ? filters.email?.trim() : undefined,
        state: filters.state != null ? filters.state.id : undefined,
        district: filters.district != null ? filters.district.id : undefined,
        page: filters.page !== 0 ? filters.page : undefined
      }
      params.order_by = filters.order_field
      params.order_direction = filters.order_direction
      return await memberListFilter(params)
    } catch (error) {
      console.error(error)
      return { data: [], page_number: 1, page_size: 1, total_pages: 1, total_items: 0 }
    }
  }

  const updateMemberTableWithFilter = async (): Promise<void> => {
    fetchMembers().then(response => {
      setMembers(response.data)
      setPageCount(response.total_pages)
      setTotalCount(response.total_items)
      setLastQueriedFilters(filters)
      if (filters.page !== response.page_number) { updateFilters({ page: response.page_number }) }
    }).catch(reason => {
      console.log(reason)
      setMembers([])
      setPageCount(0)
    }).finally(() => { setLoading(false) })
  }

  useEffect(() => {
    const updateTablePage = async (): Promise<void> => {
      await updateMemberTableWithFilter()
    }
    void updateTablePage()
  }, [loadResultWithFilters])

  return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <Box width='97%' sx={{ pb: 1 }}>
                  <MemberFilters doFilter={updateMemberTableWithFilter} filters={filters} updateFilters={updateFilters} cleanFilters={cleanFilter}/>
                                  <UsTable entities={committees} orderField={filters.order_field} orderDirection={filters.order_direction} loading={loading}
                                          pageCount={pageCount} totalCount={totalCount} triggerReload={() => { setLoadResultWithFilters(prevState => !prevState) }} openEdit={(entity) => { entity.id != null ? openNewTab(`/us/editMember/${String(entity.id)}/${String(entity.person.id)}`) : alert('No ID on this Member 🤔') }}
                                          filters={filters}
                                           updateFilters={updateFilters}
                                           openDelete={() => { alert('Committee Deleted! :p jk we can\'t do that yet') }}
                                           additionalColumns={defaultAdditionalColumns}
                                    />
                </Box>
            </Box>
  )
}
